/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="order-recap">
    <div class="order-card">
      <div class="order-card__header" @click.prevent="goToOrder">
        <div class="order-card__header-block block-order-id">
          <span class="label">{{ $t('order.order') }}</span>
          <span class="text">{{order.increment_id}}</span>
        </div>
        <div class="order-card__header-block block-shipping">
          <span class="label">{{ $t('order.shipping-method') }}</span>
          <span class="text">{{order.shipping_description}}</span>
        </div>
        <div class="order-card__header-block block-fullname">
          <span class="label">{{ $t('order.fullname') }}</span>
          <span class="text">{{fullName}}</span>
        </div>
        <div class="order-card__header-block block-telephone">
          <span class="label">{{ $t('tel') }}.</span>
          <span class="text">{{phoneNumber}}</span>
        </div>
        <div class="order-card__header-block block-qty-ordered">
          <span class="label">{{ $t('order.quantity-ordered') }}</span>
          <span class="text">{{ order.total_qty_ordered }}</span>
        </div>
        <div class="order-card__header-block block-status">
          <span class="label">{{ $t('order.status') }}</span>
          <div class="wrapp-badge" :class="[`order-status-${order.status}`]">
            <span class="text">{{ $t(`order-status.${order.status}`) }}</span>
          </div>
        </div>
        <div class="order-card__header-block block-shipment-date">
          <span class="label">{{ $t('order.shipment-date') }}</span>
          <span class="text">{{ createdAt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderCard from 'theme/components/MyAccount/Orders/OrderCard'
import TracksManager from 'theme/components/MyAccount/Orders/TracksManager'

export default {
  name: 'OrderSummary',
  mixins: [OrderCard],
  props: {
    shippingInformation: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TracksManager
  }
}
</script>
